/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AuthBaseService } from '../auth-base-service';
import { AuthApiConfiguration } from '../auth-api-configuration';
import { AuthStrictHttpResponse } from '../auth-strict-http-response';

import { roleIdGet } from '../fn/role/role-id-get';
import { RoleIdGet$Params } from '../fn/role/role-id-get';
import { RoleModel } from '../models/role-model';
import { rolePost } from '../fn/role/role-post';
import { RolePost$Params } from '../fn/role/role-post';
import { roleSearchRolePost } from '../fn/role/role-search-role-post';
import { RoleSearchRolePost$Params } from '../fn/role/role-search-role-post';
import { SearchRoleResultModelSearchResultModel } from '../models/search-role-result-model-search-result-model';

@Injectable({ providedIn: 'root' })
export class AuthRoleService extends AuthBaseService {
  constructor(config: AuthApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `roleSearchRolePost()` */
  static readonly RoleSearchRolePostPath = '/Role/SearchRole';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `roleSearchRolePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  roleSearchRolePost$Response(params?: RoleSearchRolePost$Params, context?: HttpContext): Observable<AuthStrictHttpResponse<SearchRoleResultModelSearchResultModel>> {
    return roleSearchRolePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `roleSearchRolePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  roleSearchRolePost(params?: RoleSearchRolePost$Params, context?: HttpContext): Observable<SearchRoleResultModelSearchResultModel> {
    return this.roleSearchRolePost$Response(params, context).pipe(
      map((r: AuthStrictHttpResponse<SearchRoleResultModelSearchResultModel>): SearchRoleResultModelSearchResultModel => r.body)
    );
  }

  /** Path part for operation `roleIdGet()` */
  static readonly RoleIdGetPath = '/Role/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `roleIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  roleIdGet$Response(params: RoleIdGet$Params, context?: HttpContext): Observable<AuthStrictHttpResponse<RoleModel>> {
    return roleIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `roleIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  roleIdGet(params: RoleIdGet$Params, context?: HttpContext): Observable<RoleModel> {
    return this.roleIdGet$Response(params, context).pipe(
      map((r: AuthStrictHttpResponse<RoleModel>): RoleModel => r.body)
    );
  }

  /** Path part for operation `rolePost()` */
  static readonly RolePostPath = '/Role';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rolePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  rolePost$Response(params?: RolePost$Params, context?: HttpContext): Observable<AuthStrictHttpResponse<string>> {
    return rolePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `rolePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  rolePost(params?: RolePost$Params, context?: HttpContext): Observable<string> {
    return this.rolePost$Response(params, context).pipe(
      map((r: AuthStrictHttpResponse<string>): string => r.body)
    );
  }

}
